module.exports = __webpack_public_path__ + "img/varoszoba_3.a2d27c4d.png";